import { Capacitor, registerPlugin } from '@capacitor/core';

/**
 * La langue choisie dans Sirocco, dite au telephone.
 *
 * L'interface se traduit seule ; ce que le systeme affiche pour
 * l'application — la question d'autorisation de la camera, la sonnerie
 * d'un appel sur Android — suit la langue de l'application cote natif.
 * Sans ce greffon, elle suivait celle du telephone : choisir l'anglais
 * dans Sirocco laissait ces textes-la en francais.
 *
 * `auto` rend la main au reglage du telephone. Une coquille d'avant ce
 * greffon ne l'a pas : on se tait, l'interface reste traduite.
 */
interface Greffon {
  appliquer(options: { code: string }): Promise<void>;
}

const greffon = registerPlugin<Greffon>('Langue');

export async function direLaLangueAuTelephone(preference: string): Promise<void> {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('Langue')) return;
  await greffon.appliquer({ code: preference }).catch(() => undefined);
}
